// extracted by mini-css-extract-plugin
export default {"wrapper":"FilterCheckbox_wrapper__jhEx7","isSelected":"FilterCheckbox_isSelected__7tobN"};